import React from "react"
import { Nav } from "react-bootstrap"

import * as styles from "./LanguageSelector.module.scss"

const LanguageSelector = ({language_selector, lang, withStyle}) => {
  return (
    <Nav className={styles.languages} style={withStyle}>
      {language_selector ? language_selector.map((language, index) => {
        return (
          <a key={index} className={language === lang ? styles.active : ""} href={language === "en" ? "/" : "/" + language}>{language}</a>
        )
      }) : []}
    </Nav>
  )
}

export default LanguageSelector